/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';

export const AddressTypeSchema = z.enum(["RESIDENTIAL", "BUSINESS", "BILLING", "SHIPPING", "MAILING", "LISTING"])
